import React from 'react';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Icon from '@material-ui/core/Icon';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';

import chatImg from '../../../images/eventsIcons/eventComment.png';
import sendEta from '../../../images/eventsIcons/SendETA.png';
import More from '../../../images/eventsIcons/more.png';
import shareImg1 from '../../../images/eventsIcons/share.png';
import AttendyLogo from '../../../images/eventsIcons/attendyLogo.png';
import EventBG from '../../../images/eventsIcons/Event_BG.jpg';

const styles={
    secondaryText:{
        fontSize: '12px',
        lineHeight: 1.5,
    }
};

const Block=(props)=>{
    const { event, classes } = props;
    return(
        <React.Fragment>
            <Grid container className="eventContainer">
                <Grid item sm={12}>
                    <div className='event-title'>
                        {event.Name}
                    </div>
                </Grid>
                <Grid container>
                    <Grid item sm={6} xs={6} className="img-div-app">
                        <img src={event.tempURL|| event.LogoURL || EventBG} className="img-event-block" alt='Event'/>
                        {/*<Divider className="divder"/>*/}
                    </Grid>
                    <Grid item sm={6} xs={6}>
                        <List className="list-location-performers">
                            <ListItem className="eventListItem" disableGutters>
                                <ListItemIcon className="eventItemIcon">
                                    <Icon>location_on</Icon>
                                </ListItemIcon>
                                <ListItemText primary="LOCATION"
                                              secondary={
                                                  <div style={{width:'60%', marginTop: '5px' }}>
                                                                              <div className='event-location event-text-bold eventlist-location-elipsis'>
                                                                                  {event.EventVenueName|| ''}
                                                                              </div>
                                                      <Divider style={{opacity:0}}/>
                                                      <span>
                                                                                  <div className="eventlist-location-elipsis">
                                                                                    {event.Add1 || event.Add2}
                                                                                  </div>
                                                                                  <div className="eventlist-location-elipsis">
                                                                                    {event.City} {(event.City)&& ', '} {event.Region}
                                                                                  </div>
                                                                              </span>
                                                  </div>
                                              }
                                              className="eventTextRoot"
                                              primaryTypographyProps={{
                                                  className: "eventListItemText"
                                              }}
                                />
                            </ListItem>
                            <Divider/>
                            <ListItem className="eventListItem" disableGutters>
                                <ListItemIcon className="eventItemIcon">
                                    <Icon>access_time</Icon>
                                </ListItemIcon>
                                <ListItemText primary="DATE"
                                              secondary={
                                                  <div>
                                                      {moment(moment.utc(event.startDateTime,'MM/DD/YYYY hh:mm A').toDate()).local().format('ddd, MMM DD hh:mm A')}
                                                      <br/>
                                                      {(event.endDateTime!=='')? moment(moment.utc(event.endDateTime).toDate()).local().format('ddd, MMM DD hh:mm A'):""}
                                                  </div>
                                              }
                                              className="eventTextRoot"
                                              primaryTypographyProps={{
                                                  className: "eventListItemText"
                                              }}
                                              secondaryTypographyProps={{
                                                  className:classes.secondaryText
                                              }}
                                />
                            </ListItem>
                            <Divider/>
                            <ListItem className="eventListItem" disableGutters>
                                <ListItemIcon className="eventItemIcon">
                                    <Icon>event_available</Icon>
                                </ListItemIcon>
                                <ListItemText primary="PERFORMERS"
                                              secondary={event.Performer || 'No Performers Listed.'}
                                              className="eventTextRoot"
                                              style={{ overflow: 'hidden', textoverflow: 'ellipsis', width: '150px', display: '-webkit-box', WebkitLineClamp: '2', WebkitBoxOrient: 'vertical' }}
                                              primaryTypographyProps={{
                                                  className: "eventListItemText"
                                              }}
                                              secondaryTypographyProps={{
                                                  className:classes.secondaryText
                                              }}
                                />
                            </ListItem>

                        </List>
                    </Grid>

                    <Grid container style={{ marginBottom : '8px' }}>
                        <Divider className="divider-line"/>
                        <Grid item sm={3} xs={3}>
                            <img src={shareImg1} className="share-img-event"/>
                        </Grid>
                        <Grid item sm={3} xs={3}>
                            <img src={chatImg} className="chat-img-event"/>
                        </Grid>
                        <Grid item sm={4} xs={3}>
                            <img src={sendEta} className="send-img-event"/>
                        </Grid>
                        <Grid item sm={2} xs={3}>
                            <img src={More} className="more-img-event"/>
                        </Grid>
                    </Grid>
                    <Divider className='divider'/>
                    <Grid container>
                        <Grid item>
                            <div className="event-user">
                               <div> <img src={AttendyLogo}
                                          style={{margin: '0 20px',width: '20px'}}/></div>
                                {
                                    <div style={{color:'#851679'}}>{event.EventAttendiesNames}</div>
                                }
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
                <Divider className='divider'/>
            </Grid>
        </React.Fragment>
    )
};

export default withStyles(styles)(Block);